export default {
  app: {
    privacy: {
      policy: 'політика конфіденційності',
      expansive: 'Використовуючи Expansive, ви погоджуєтеся з {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Сесія завершена',
    sessionExpiredDescription:
      'Ваша сесія завершилася. Будь ласка, увійдіть знову, щоб продовжити користування додатком.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Оберіть мову',
      chooseLanguageDescription:
        'Оберіть бажану мову для додатку. Це змінить мову інтерфейсу та контенту.',
    },
    userSelection: {
      cancel: 'Скасувати',
      createNewUser: 'Їхнє ім’я відсутнє у списку',
      newUser: 'Новий користувач',
      selectAnExistingUser: 'Оберіть існуючого користувача',
      selectUserHint: 'Оберіть існуючого користувача або створіть нового, щоб продовжити.',
      startTypingToSearch: 'Почніть вводити...',
    },
    verification: {
      codeVerification: {
        continue: 'Продовжити',
        header: 'Введіть код доступу до об’єкта',
        invalidCode: 'Невірний код, спробуйте ще раз.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Продовжити без перевірки місцезнаходження',
        enterSiteAccessCode: "Введіть код доступу до об'єкта",
        locationNotEnabledOrAvailable: 'Чому я це бачу?',
        notAvailable: {
          description: 'Місцезнаходження GPS не підтримується на цьому пристрої.',
          header: 'Місцезнаходження не підтримується',
        },
        notEnabled: {
          description: 'Служби геолокації не увімкнено або дозвіл не надано.',
          header: 'Місцезнаходження не увімкнено',
        },
        notVerified: {
          description: 'GPS вказує, що ви не на об’єкті.',
          header: 'Місцезнаходження не підтверджено',
        },
        tryAgain: 'Спробувати ще раз',
        unavailable: {
          description: 'Не вдалося перевірити ваше місцезнаходження GPS.',
          header: 'Місцезнаходження недоступне',
        },
        unknown: {
          description: 'Не вдалося визначити ваше місцезнаходження.',
          header: 'Місцезнаходження невідоме',
        },
        verified: {
          description: 'GPS вказує, що ви на об’єкті.',
          header: 'Місцезнаходження підтверджено',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Обладнання не знайдено',
        emptyDescription: 'З цим нарядом не пов’язано жодного обладнання.',
        warrantyParts: 'Гарантія на деталі закінчується',
        serialNumber: 'Серійний номер',
        none: '<немає>',
      },
      updates: {
        emptyTitle: 'Оновлення не знайдено',
        emptyDescription: 'Для цього наряду немає оновлень.',
        unknownUser: 'Невідомий користувач',
        none: 'Немає',
        addComment: {
          buttonLabel: 'Додати коментар',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Небезпеки',
          no: 'Ні',
          yes: 'Так',
        },
      },
    },
    attachmentsList: {
      attachments: 'Вкладення',
      documents: 'Документи',
      siteDocuments: 'Документи об’єкта',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Небезпеки',
        induction: 'Інструктаж',
        safeToProceed: 'Безпечно продовжувати',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Термін виконання',
        activeSessions: 'Активні сесії',
        activeSessionsDescription:
          'Ви вже зареєстровані на наступних нарядах. Ви повинні вийти з цих нарядів перед тим, як зареєструватися на новий.',
        resumeSession: 'Відновити',
        startTime: 'Почато о',
        unexpectedErrorTitle: 'Неочікувана помилка',
        unexpectedErrorMessage:
          'Під час створення ваших сесій сталася неочікувана помилка. Будь ласка, спробуйте пізніше.',
        engineerNotFound: 'Інженера не знайдено',
        engineerNotFoundDescription:
          'Інженера, якого ви намагаєтеся зареєструвати, не знайдено в системі. Зверніться до адміністратора.',
      },
      verification: {
        code: {
          description:
            'Щоб зареєструватися, отримайте 4-значний код у менеджера об’єкта або відповідальної особи.',
        },
        geo: {
          continue: 'Продовжити',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Будь ласка, отримайте код доступу від керівника об’єкта або призначеного контакту для завершення вашого візиту.',
            checkOut: 'Вийти',
            completeBeforeLeaving: 'Будь ласка, заповніть цю форму перед виходом.',
            continue: 'Продовжити',
            noResolutionSelected: 'Будь ласка, оберіть рішення перед продовженням.',
            quoteRequired: {
              hint: 'Візит завершено, буде надано кошторис',
              label: 'Потрібен кошторис',
            },
            returnVisitRequired: {
              hint: 'Ми повернемося для завершення',
              label: 'Потрібен повторний візит',
            },
            serviceCompleted: {
              hint: 'Додаткових дій не потрібно',
              label: 'Послугу виконано',
            },
            uploadCheckout: 'Завантажити файл, фото або відео',
            visitNotes: 'Примітки до візиту',
            workOrderResolution: 'Рішення по наряду',
            enterNotes: 'Введіть будь-які примітки тут...',
            errors: {
              timedOut: 'Час вийшов, перевищено 30 секунд. Будь ласка, спробуйте ще раз.',
              closingSession: 'Помилка при закритті сесії',
            },
          },
          success: {
            description:
              'Дякуємо за відвідування {site}. | На {site} залишився 1 відкритий наряд. | На {site} залишилося {count} відкритих нарядів.',
            endVisit: 'Завершити візит',
            header: 'Ви успішно вийшли',
            viewWorkOrders: 'Зареєструватися на інший наряд',
          },
          verification: {
            code: {
              description:
                'Щоб вийти, отримайте 4-значний код у менеджера об’єкта або відповідальної особи.',
              continue: 'Продовжити',
            },
            geo: {
              checkOut: 'Вийти',
              continue: 'Продовжити',
            },
          },
        },
        detail: {
          assets: 'Обладнання',
          call: 'Дзвінок',
          checkOut: 'Вийти',
          closed: 'Закрито',
          details: 'Деталі',
          dueBy: 'Термін виконання',
          manageEngineers: 'Керувати інженерами',
          notAvailable: 'Недоступно',
          pointOfContact: 'Контактна особа',
          siteAccessTimes: "Час доступу до об'єкта",
          siteAccessInstructions: 'Інструкції з доступу',
          siteAddress: "Адреса об'єкта",
          siteNotes: 'Примітки до об’єкта',
          siteTelephone: 'Телефон об’єкта',
          siteLocation: 'Місцезнаходження об’єкта',
          updates: 'Оновлення',
          more: 'Більше',
          mismatchErrorTitle: 'Помилка наряду',
          mismatchErrorMessage:
            'Наряд, до якого ви намагаєтеся отримати доступ, не відповідає тому, на який ви зараз зареєстровані. Перевірте наряд і спробуйте ще раз.',
          siteDocuments: 'Документи об’єкта',
          validFrom: 'Дійсний з',
          validUntil: 'Дійсний до',
          documentName: 'Назва документа',
          documentType: 'Тип документа',
          attachments: 'Файли наряду',
          download: 'Завантажити',
          workDetails: 'Деталі роботи',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Додати помічника-інженера',
            assistantEngineers: 'Помічники-інженери',
            description:
              'З міркувань безпеки, будь ласка, вкажіть імена всіх інженерів на об’єкті.',
            editMainEngineer: 'Редагувати головного інженера',
            errors: {
              creatingEngineer: 'Помилка при створенні інженера',
              creatingSession: 'Помилка при створенні сесії',
            },
            header: 'Інженери на об’єкті',
            mainEngineer: 'Головний інженер',
            newAssistantEngineer: 'Введіть їхнє повне ім’я',
            next: 'Далі',
            removeEngineer: 'Видалити інженера',
            selectExistingAssistantEngineer: 'Почніть вводити їхнє ім’я',
          },
          index: {
            description:
              'З міркувань безпеки, будь ласка, вкажіть імена всіх інженерів на об’єкті.',
            errorCreatingEngineer: 'Помилка при створенні інженера, спробуйте ще раз.',
            header: 'Інженери на об’єкті',
            hintMainEngineer: 'Введіть повне ім’я головного інженера',
            newMainEngineer: 'Новий головний інженер',
            next: 'Далі',
            selectExistingMainEngineer: 'Оберіть існуючого головного інженера',
            yes: 'Так',
            no: 'Ні',
            mainEngineerLabel: 'Ви головний інженер?',
          },
        },
        index: {
          callUsOn: 'Зателефонуйте нам за номером {phoneNumber}',
          description: 'Не можете знайти те, що шукаєте?',
          dueBy: 'Термін виконання',
          header: 'Оберіть наряд',
          notAvailable: 'Недоступно',
          searchWorkOrders: 'Пошук нарядів...',
        },
        manageEngineers: {
          manageEngineers: 'Керувати інженерами',
          notWorking: 'Неактивні працівники',
          pause: 'Пауза',
          resume: 'Відновити',
          workingNow: 'Активні працівники',
          startTime: 'Час початку',
          endTime: 'Час завершення',
          duration: 'Тривалість',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Зворотний зв’язок',
            feedbackDescription:
              'Будь ласка, залиште відгук про наряд, щоб допомогти нам покращити наші послуги.',
            feedbackLabel: 'Відгук',
            filesLabel: 'Вкладення',
            submissionLabel: 'Надіслати відгук',
          },
          hazards: {
            back: 'Назад',
            hazards: 'Небезпеки',
            next: 'Далі',
            no: 'Ні',
            noTasksForHazard: 'Для цієї небезпеки немає завдань.',
            yes: 'Так',
          },
          induction: {
            continue: 'Продовжити',
            induction: 'Інструктаж',
          },
          index: {
            checkIn: 'Зареєструватися',
            description: 'Будь ласка, виконайте оцінку ризиків для обраної роботи.',
            fail: 'Не вдалося обробити перевірки початку роботи.',
            haltMessage:
              'Виявлено потенційні ризики. Зупиніть роботу, ознайомтеся з інструкціями з безпеки та зверніться до керівника.',
            header: 'Перевірки перед початком роботи',
            endVisit: 'Завершити візит',
            leaveFeedback: 'Залишити відгук',
          },
          safeToProceed: {
            continue: 'Продовжити',
            safeToProceed: 'Безпечно продовжувати',
          },
        },
      },
    },
    index: {
      title: 'Ласкаво просимо',
      description: 'Скануйте QR-код на вашій локації, щоб почати.',
    },
    login: {
      errorTitle: 'Неочікувана помилка',
      errorMessage: 'Сталася неочікувана помилка. Спробуйте відсканувати QR-код ще раз.',
    },
    unauthenticated: {
      welcome: {
        title: 'Ласкаво просимо до {site}',
        description:
          'Перш ніж ми покажемо вам наряди, нам потрібно перевірити ваші дані. Натисніть кнопку нижче, щоб продовжити.',
        next: 'Продовжити',
      },
      index: {
        errorTitle: 'Неочікувана помилка',
        errorMessage: 'Сталася неочікувана помилка. Спробуйте відсканувати QR-код ще раз.',
      },
      contractor: {
        title: 'На кого ви працюєте?',
        contractor: 'Підрядник',
        contractorLabel: 'Почніть вводити назву компанії',
        contractorHint: 'Введіть 3 або більше символів, щоб побачити результати',
        defaultSelectPlaceholder: '--Оберіть--',
        next: 'Далі',
      },
      user: {
        title: 'Хто ви?',
        cancel: 'Скасувати',
        createNewUserLabel: 'Моє ім’я відсутнє у списку',
        existingUserLabel: 'Почніть вводити своє ім’я',
        existingUserHint: 'Введіть 3 або більше символів, щоб побачити результати',
        newUserLabel: 'Введіть своє повне ім’я',
        next: 'Далі',
        user: 'Користувач',
      },
      verification: {
        methods: {
          add: {
            add: 'Додати спосіб верифікації',
            defaultSelectPlaceholder: '--Оберіть--',
            emailLabel: 'Електронна пошта',
            existingMethodWarning:
              'У вас вже є запит на цей спосіб верифікації, що очікує на підтвердження адміністратора. Додавання нового скасує попередній.',
            method: 'Спосіб',
            methodLabel: 'Спосіб',
            mobileCountryHint: 'Оберіть код країни',
            mobileCountryLabel: 'Код країни мобільного',
            mobileHint: 'Введіть номер мобільного',
            mobileLabel: 'Мобільний',
            title: 'Додати спосіб верифікації',
          },
          confirm: {
            confirm: 'Підтвердити',
            description: 'Підтвердіть спосіб верифікації, щоб продовжити.',
            label: 'Введіть код',
            resend: 'Надіслати ще раз',
            resendPrompt: 'Не отримали код?',
            title: 'Підтвердження способу верифікації',
          },
          confirmed: {
            description:
              'Вас повідомлять, коли цей спосіб буде підтверджено адміністратором, і ви зможете використовувати його для верифікації особи.',
            forceApproval: 'Поки не підтверджено, ви не можете отримати доступ до нарядів.',
            nonForceApproval: 'Тим часом ви можете продовжити з обмеженим доступом.',
            nonForceApprovalButtonLabel: 'Продовжити з обмеженим доступом',
            title: 'Очікує на підтвердження',
          },
          addNew: 'Додати новий спосіб верифікації',
          description: 'Ми повинні підтвердити вашу особу, щоб надати повний доступ до наряду.',
          email: 'Електронна пошта',
          hint: 'Ми надішлемо посилання на обраний спосіб, що дасть повний доступ до наряду. Якщо потрібно змінити існуючі способи, зверніться до адміністратора.',
          label: 'Оберіть спосіб верифікації',
          next: 'Далі',
          pendingHint: 'Очікує на підтвердження адміністратора',
          sms: 'SMS',
          title: 'Верифікація',
        },
        optional: {
          hint: 'Верифікація ваших даних дасть повний доступ до наряду',
          label: 'Бажаєте верифікувати свої дані?',
          next: 'Далі',
          no: 'Ні',
          noHint: 'Я не хочу верифікувати свої дані та продовжити з обмеженим доступом до наряду',
          title: 'Верифікація',
          yes: 'Так',
          yesHint: 'Я хочу верифікувати свої дані та отримати повний доступ до наряду',
        },
        sent: {
          description:
            'Посилання для входу надіслано на {identifier}. Перейдіть за посиланням для завершення входу.',
          title: 'Посилання для входу надіслано',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Вчора',
      today: 'Сьогодні',
      days: {
        monday: 'Понеділок',
        tuesday: 'Вівторок',
        wednesday: 'Середа',
        thursday: 'Четвер',
        friday: 'П’ятниця',
        saturday: 'Субота',
        sunday: 'Неділя',
      },
      months: {
        january: 'Січень',
        february: 'Лютий',
        march: 'Березень',
        april: 'Квітень',
        may: 'Травень',
        june: 'Червень',
        july: 'Липень',
        august: 'Серпень',
        september: 'Вересень',
        october: 'Жовтень',
        november: 'Листопад',
        december: 'Грудень',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Щось пішло не так',
      message: 'Спробуйте відсканувати QR-код ще раз.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Невідомий користувач',
      },
      none: 'Немає',
      types: {
        stateTransition: 'Статус змінено',
        contractorAssigned: 'Підрядника призначено',
        engineerAssigned: 'Інженера призначено',
        serviceAssigned: 'Послугу призначено',
        priorityChanged: 'Пріоритет змінено',
        actionableDateChanged: 'Дату виконання змінено',
        dueDateChanged: 'Дату завершення змінено',
        etaDateChanged: 'Дату прибуття змінено',
        spendLimitApproved: 'Ліміт витрат затверджено',
        spendLimitCancelled: 'Запит на ліміт витрат скасовано',
        spendLimitRejected: 'Ліміт витрат відхилено',
        spendLimitRequested: 'Запит на ліміт витрат',
        jobSheetUploaded: 'Завантажено лист виконаних робіт',
        slaAlertSent: 'Перевищено час реагування (SLA)',
        issuedWorkPermit: 'Видано дозвіл на роботу',
        requestForServiceSent: 'Відправлено запит на послугу',
        comment: 'Додано коментар',
        unknown: 'Невідома подія',
      },
      labels: {
        actionableDate: 'Дата виконання',
        comment: 'Коментар',
        file: 'Файл',
        contractor: 'Підрядник',
        dueDate: 'Дата завершення',
        etaDate: 'Дата прибуття',
        engineer: 'Інженер',
        priority: 'Пріоритет',
        requestForService: 'Запит на послугу',
        service: 'Послуга',
        spendLimit: 'Ліміт витрат',
        status: 'Статус',
        workPermit: 'Дозвіл на роботу',
      },
    },
  },
}
